import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, FreeMode } from "swiper/modules";
import MainPlate from '../MainPlate';
import { useMainPlates } from '../../../../hooks/useMainPlates';

import 'swiper/css';
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/free-mode";
import styles from './MainPlates.module.scss';
import React from 'react';


export const MainPlates = () => {
    const { sections, hasData } = useMainPlates();

    if (!hasData) return null;




    return (
        <div className={styles.cardsPlates}>
            {sections.map((section) => (
                <section key={section.title} className={styles.featureSection}>
                    <h3 className={styles.mainHeader}>{section.title}</h3>

                    <Swiper
                        spaceBetween={12}
                        freeMode
                        watchSlidesProgress
                        watchOverflow
                        modules={[Navigation, Pagination, FreeMode]}
                        breakpoints={{
                            0: { slidesPerView: 'auto' },
                            768: { slidesPerView: 'auto' },
                        }}
                        navigation
                    >
                        {section.products.map((product) => (
                            <SwiperSlide key={product.id} className={styles.mainPlateSlide}>
                                <MainPlate plate={product} />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </section>
            ))}
        </div>
    );
};